<script>
  import SongSearch from "../../../quickchords-vue/src/components/SongSearch";

  const htmlentities = {
    /**
     * Converts a string to its html characters completely.
     *
     * @param {String} str String with unescaped HTML characters
     **/
    encode: function (str) {
      var buf = [];

      for (var i = str.length - 1; i >= 0; i--) {
        buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
      }

      return buf.join('');
    },
    /**
     * Converts an html characterSet into its original character.
     *
     * @param {String} str htmlSet entities
     **/
    decode: function (str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    }
  };

  export default {
    name: "WikiaSearch",
    extends: SongSearch,
    components: {SongSearch},
    data: function () {
      return {}
    },
    created() {
      this.serviceName = 'Wikia'
    },
    props: {
      proxyUrl: {type: String, required: true}
    },
    computed: {},
    methods: {
      getSearchUrl(options) {
        let baseUrl = "http://lyrics.wikia.com/wiki/Special:Search?query=";

        let song1 = options.title || ""
        //song1 = song1.replace(/[ ]/g, "");

        let artist1 = options.artist || ""
        //artist1 = artist1.replace(/[ _-]/g, "_");
        if (artist1 !== "") {
          artist1 += ":"
        }

        let url = baseUrl + artist1 + song1;
        return url
      },
      getSearchItems(options) {
        return new Promise((resolve, reject) => {
          let proxy = `${this.proxyUrl}/rest/qc/proxy?url=${encodeURIComponent(this.getSearchUrl(options))}`
          fetch(proxy)
            .then(res => res.text())
            .then(text => {
              //console.log(text)
              const items = []
              const rx = /<article>[\s\S]*?<h1>[\s\S]*?<a ([^>]+)>([^<]+)<\/a>[\s\S]*?<\/h1>[\s\S]*?<\/article>/g
              const rxHref = /href="([\s\S]*?)"/
              let m
              while ((m = rx.exec(text)) != null) {
                let [artist, title] = m[2].split(':')
                let href
                let mm = rxHref.exec(m[1])
                if (mm) {
                  href = mm[1]
                }
                // some items do not have both (artist only)
                if (artist && title){
                  items.push({tab_url: href, artist_name: artist, song_name: title})
                }
              }
              //const n = dom.window.document.querySelectorAll('article h1 a')
              //let items = Array.from(n);
              //let mapped = items.map(it => ({song_name: it.text, artist_name: 'Anon', tab_url: it.href}))
              resolve(items)
            }).catch(reason => reject(reason))
          // JSDOM.fromURL(proxy)
          //   .then(dom => {
          //     setTimeout(() => {
          //       console.log(dom.window.document.body.innerHTML)
          //       const n = dom.window.document.querySelectorAll('article h1 a')
          //       let items = Array.from(n);
          //       let mapped = items.map(it => ({song_name: it.text, artist_name: 'Anon', tab_url: it.href}))
          //       resolve(mapped)
          //     }, 4000)
          //   }).catch(reason => reject(reason));
        });
      },
      getDocument(url, options) {
        return new Promise((resolve, reject) => {
          let proxy = 'https://www.quickchords.org:9999/rest/qc/proxy?url=' + encodeURIComponent(url)
          fetch(proxy)
            .then(res => res.text())
            .then(text => {
              const rx = /<div class='lyricbox'>([\s\S]*?)<\/div>/
              let m = rx.exec(text)
              if (m) {
                let lyrics = htmlentities.decode(m[1])
                lyrics = lyrics.replace(/<br \/>/g, '\n')
                lyrics = lyrics.replace(/<div class='lyricsbreak'>/, "\n\\\\\n")
                // Remove the final line break
                lyrics = lyrics.replace(/\\\\\s*$/, "")
                const header = `:title ${options.title}
:artist ${options.artist}
:flavor lyrics
:lyrics-font-size fit

:lyrics
`
                const doc = header + lyrics + "\n.\n"
                resolve(doc)
              } else {
                reject("lyrics not found")
              }
            })
            .catch(reason => reject(reason))
        });
      },
    },
  }
</script>